<template>
    <div class="tab-content p-2 text-center" v-if="!isLoaded">
        {{ $t('loading') }}
    </div>
    <div v-else>
        <div class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
            <div class="text-center p-2 mb-4">
                <h3>AUBE</h3>
                <p>{{ $t('aube_quest.integrate.cooperation_confirmation') }}</p>
            </div>
            <div class="default-box mb-3 d-flex justify-content-between">
                <small class="text-muted">{{ $t('aube_quest.integrate.account') }}</small>
                <span class="font-weight-bold">{{ formData.email }}</span>
            </div>
            <div class="info-box">
                <small class="text-muted">{{ $t('aube_quest.connect.quest_information') }}</small>
                <div>Quest ID: {{ formData.questId }}</div>
                <div class="text-danger">{{ error }}</div>
            </div>
            <p class="text-center my-3">{{ $t('aube_quest.integrate.collaborate_on_the_above_content') }}</p>
            <div class="d-flex justify-content-between">
                <button class="btn btn-outline-secondary w-50 mr-2" @click="switchAccount">
                    {{ $t('aube_quest.integrate.switch_account') }}
                </button>
                <button class="btn btn-primary w-50 ml-2" @click="confirm">
                    {{ $t('aube_quest.integrate.confirm') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from '../../../services/UserService';
import AuthUtil from "../../../utils/AuthUtil";

export default {
    name: 'user-quest-link-confirm',
    data() {
        return {
            formData: {
                questId: null,
                email: null
            },
            invalidQuestId: false,
            error: null
        };
    },
    created() {
        const questId = localStorage.getItem('questId');
        if (questId) {
            this.formData.questId = questId;
            this.getEmail();
            this.isLoaded = true;
        }
    },
    methods: {
        async switchAccount() {
            try {
                await UserService.revokeToken(AuthUtil.getAuthToken());
            } catch (error) {

            }
            await this.$router.push({
                path: '/login-quest',
                query: { token: this.formData.token }
            })
        },
        async getEmail() {
            try {
                const data = await UserService.getUserFrontendData();
                this.formData.email = data.data.email;
                if (this.formData.questId != data.data.quest.quest_id) {
                    this.invalidQuestId = true;
                    this.error = 'Quest ID invalid';
                }
            } catch (e) {
                this.isValidToken.verified = false;
            } finally {
            }
        },
        async confirm() {
            if (this.invalidQuestId) {
                return;
            }
            try {
                await this.$router.push('/connected-quest');
            } catch (e) {
                this.error = e.response.data.message;
            } finally {
            }
        }
    }
}
</script>

<style scoped>

.info-box {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.btn-primary {
    background: #451493 !important;
    border-color: #451493 !important;
}

.btn-primary:hover {
    color: #fff !important;
    background-color: #350f71 !important;
    border-color: #300e66 !important;
}

.default-box {
    border: darkgray solid 1px;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
}
</style>
